import FJUploadImageModalContainer from '../FJTextToImage/FJTextToImageLeft/container/FJUploadImageModalContainer';
import FJLoadingModalContainer from './FJLoadingModal/FJLoadingModalContainer';
import FJPreviewModalContainer from './FJPreviewModal/FJPreviewModalContainer';
// import FJUpgradeModalContainer from './FJUpgradeModal/FJUpgradeModalContainer';
import FJWarningModalContainer from './FJWarningModal/FJWarningModalContainer';
import FJMobilePreviewModalContainer from './FJMobilePreviewModal/FJMobilePreviewModalContainer';
import FJGlobalLoadingContainer from './FJGlobalLoading/FJGlobalLoadingContainer';
import FJUpgradesTipsContainer from './FJUpgradesTips/FJUpgradesTipsContainer';
import useIsMobile from '../../hooks/useIsMobile';
import FJMobileSimplePreviewModalContainer from './FJMobileSimplePreviewModal/FJMobileSimplePreviewModalContainer';
import FJGuideModalContainer from './FJGuideModal/FJGuideModalContainer';
import FJRecordModalContainer from './FJRecord/container/FJRecordModalContainer.jsx';
import FJRecorderDelayContainer from './FJRecord/container/FJRecorderDelayContainer.jsx';
import FJAddMediaLibraryInfoModalContainer from './FJAddMediaLibraryInfoModal/FJAddMediaLibraryInfoModalContainer.jsx';
import FJAutoSelectionNoticeModalContainer from './FJAutoSelectionNoticeModal/FJAutoSelectionNoticeModalContainer.jsx';
import FJVideoTrimContainer from '../FJAiVideoDub/FJAiVideoDubLeft/container/FJVideoTrimContainer.jsx';
import FJServerBusyModalContainer from './FJServerBusyModal/FJServerBusyModalContainer.jsx';
import FJTimeDiscountPanel from './FJTimeDiscountPanel/FJTimeDiscountPanel.jsx';
import FJProgressModalContainer from './FJProgressModal/FJProgressModalContainer.jsx';
import FJMediaPreviewContainer from './FJMediaPreview/FJMediaPreviewContainer.jsx';
import FJVoiceCloneEditContainer from './FJVoiceCloneEdit/container/FJVoiceCloneEditContainer.jsx';
import FJTextToSpeechModalContainer from './FJTextToSpeechModal/container/FJTextToSpeechModalContainer.jsx';
import FJTTVLibraryModalContainer from './FJTTVLibraryModal/container/FJTTVLibraryModalContainer.jsx';
import FJDoNotShowAgainModalContainer from './FJDoNotShowAgainModal/FJDoNotShowAgainModalContainer.jsx';
import FJImageCropModalContainer from './FJImageCropModal/FJImageCropModalContainer.jsx';
import FJCloudTranscodingModalContainer from './FJCloudTranscodingModal/FJCloudTranscodingModalContainer.jsx';
import FJDetailsPreviewModalContainer from './FJDetailsPreviewModal/container/FJDetailsPreviewModalContainer.jsx';
import FJReportModalContainer from './FJReportModal/container/FJReportModalContainer.jsx';

const FJModals = () => {
    const isMobile = useIsMobile();
    const _renderMobileModal = () => {
        if (!isMobile) {
            return null;
        }
        return (
            <>
                <FJMobilePreviewModalContainer />
                <FJMobileSimplePreviewModalContainer />
                <FJAutoSelectionNoticeModalContainer />
                <FJTimeDiscountPanel />
            </>
        );
    };
    return (
        // 在 FJModals 中集成
        <>
            <FJWarningModalContainer />
            <FJPreviewModalContainer />
            {/* <FJUpgradeModalContainer /> */}
            <FJUploadImageModalContainer />
            <FJLoadingModalContainer />
            <FJGlobalLoadingContainer />
            <FJUpgradesTipsContainer />
            <FJGuideModalContainer />
            <FJRecordModalContainer />
            <FJRecorderDelayContainer />
            <FJAddMediaLibraryInfoModalContainer />
            <FJVideoTrimContainer />
            <FJServerBusyModalContainer />
            <FJProgressModalContainer />
            <FJMediaPreviewContainer />
            <FJVoiceCloneEditContainer />
            <FJTextToSpeechModalContainer />
            <FJTTVLibraryModalContainer />
            <FJDoNotShowAgainModalContainer />
            <FJImageCropModalContainer />
            <FJCloudTranscodingModalContainer />
            <FJDetailsPreviewModalContainer />
            <FJReportModalContainer />
            {_renderMobileModal()}
        </>
    );
};
export default FJModals;
